import { render, staticRenderFns } from "./ConfigImportView.vue?vue&type=template&id=aa2cb6b4"
import script from "./ConfigImportView.vue?vue&type=script&lang=js"
export * from "./ConfigImportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports